import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { AssessAssistantComponent } from '../components/assess-assistant/assess-assistant.component';

@Component({
  selector: 'closed',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    RouterOutlet,
    AssessAssistantComponent
  ],
  templateUrl: './closed.component.html',
  styleUrl: './closed.component.css'
})
export class ClosedComponent {

}
